// extracted by mini-css-extract-plugin
export default {"main":"perfeito_main__AJJrV","title":"perfeito_title__jERQ8"};